// AWS API configuration
const AWS_API_URL = process.env.REACT_APP_AWS_API_URL;
const API_KEY = process.env.REACT_APP_API_KEY;

if (!AWS_API_URL) {
  console.error('REACT_APP_AWS_API_URL environment variable is required');
}

// Validate API URL for security
const validateApiUrl = (url) => {
  try {
    const parsedUrl = new URL(url);
    // Only allow HTTPS and AWS domains
    return parsedUrl.protocol === 'https:' && 
           parsedUrl.hostname.endsWith('.amazonaws.com');
  } catch {
    return false;
  }
};

if (AWS_API_URL && !validateApiUrl(AWS_API_URL)) {
  console.error('Invalid API URL - must be HTTPS AWS endpoint');
}

const fetchAPI = async (endpoint, options = {}) => {
  try {
    const method = options.method || 'GET';
    const headers = {
      'Content-Type': 'application/json',
      ...options.headers
    };
    
    // Add API key if available
    if (API_KEY) {
      headers['x-api-key'] = API_KEY;
    }
    
    // Add cache-busting parameter for GET requests
    const cacheBuster = method === 'GET' ? `?_t=${Date.now()}&r=${Math.random()}` : '';
    
    const response = await fetch(`${AWS_API_URL}${endpoint}${cacheBuster}`, {
      method,
      mode: 'cors',
      credentials: 'omit',
      headers,
      ...options
    });
    
    if (!response.ok) {
      let errorText = 'Unknown error';
      try {
        errorText = await response.text();
      } catch (e) {
        console.error('Could not read error response:', e);
      }
      console.error(`API Error ${response.status}:`, errorText);
      throw new Error(`Server error (${response.status}): ${errorText}`);
    }
    
    const data = await response.json();
    // AWS returns array directly, but app expects {posts: array}
    return Array.isArray(data) ? { posts: data } : data;
  } catch (error) {
    console.error('AWS API Error:', error);

    throw new Error('Unable to fetch data. Please try again later.');
  }
};



export const articlesAPI = {
  getArticles: async (page = 1, limit = 10) => {
    return await fetchAPI('/test-articles');
  },
  
  getArticle: async (id) => {
    const response = await fetchAPI('/test-articles');
    const articles = response.posts || [];
    return articles.find(article => article.id === id);
  },
  
  getFeaturedArticles: async () => {
    const response = await fetchAPI('/test-articles');
    return { posts: (response.posts || []).slice(0, 6) };
  },
  
  getArticlesByCategory: async (categoryId, limit = 10) => {
    const response = await fetchAPI('/test-articles');
    const articles = response.posts || [];
    const categoryMap = { 1: 'film', 2: 'tv', 3: 'awards', 4: 'festivals', 5: 'reviews' };
    const categoryName = categoryMap[categoryId];
    const filtered = articles.filter(article => 
      article.category && article.category.toLowerCase() === categoryName
    );
    return { posts: filtered.slice(0, limit) };
  },
  
  searchArticles: async (query) => {
    const response = await fetchAPI('/test-articles');
    const articles = response.posts || [];
    const filtered = articles.filter(article => 
      article.title.toLowerCase().includes(query.toLowerCase()) ||
      article.content.toLowerCase().includes(query.toLowerCase())
    );
    return { posts: filtered };
  },

  createArticle: async (article) => {
    return await fetchAPI('/test-articles', {
      method: 'POST',
      body: JSON.stringify(article)
    });
  },

  updateArticle: async (id, article) => {
    return await fetchAPI('/test-articles', {
      method: 'POST',
      body: JSON.stringify({...article, id, isUpdate: true})
    });
  },

  deleteArticle: async (id) => {
    return await fetchAPI('/test-articles', {
      method: 'POST',
      body: JSON.stringify({ 
        id, 
        isDelete: true,
        title: '',
        content: '',
        author: '',
        category: ''
      })
    });
  }
};

export const categoriesAPI = {
  getCategories: () => Promise.resolve([
    { id: 1, name: 'Film', slug: 'film' },
    { id: 2, name: 'TV', slug: 'tv' },
    { id: 3, name: 'Awards', slug: 'awards' },
    { id: 4, name: 'Festivals', slug: 'festivals' },
    { id: 5, name: 'Reviews', slug: 'reviews' }
  ])
};